__turbopack_context__.v({
  "active": "OiXoYq_active",
  "featured-mosaic-background": "OiXoYq_featured-mosaic-background",
  "featured-mosaic-background__overlay": "OiXoYq_featured-mosaic-background__overlay",
  "featured-mosaic-background__overlay--blue": "OiXoYq_featured-mosaic-background__overlay--blue",
  "featured-mosaic-background__overlay--green": "OiXoYq_featured-mosaic-background__overlay--green",
  "featured-mosaic-background__overlay--light": "OiXoYq_featured-mosaic-background__overlay--light",
  "featured-mosaic-background__overlay--medium": "OiXoYq_featured-mosaic-background__overlay--medium",
  "featured-mosaic-background__overlay--purple": "OiXoYq_featured-mosaic-background__overlay--purple",
  "featured-mosaic-background__overlay--red": "OiXoYq_featured-mosaic-background__overlay--red",
  "featured-mosaic-background__overlay--strong": "OiXoYq_featured-mosaic-background__overlay--strong",
  "featured-mosaic-background__overlay--yellow": "OiXoYq_featured-mosaic-background__overlay--yellow",
  "featured-mosaic-container": "OiXoYq_featured-mosaic-container",
  "featured-mosaic-container--theme-blue": "OiXoYq_featured-mosaic-container--theme-blue",
  "featured-mosaic-container__content": "OiXoYq_featured-mosaic-container__content",
  "featured-mosaic-container__content--reverse-layout": "OiXoYq_featured-mosaic-container__content--reverse-layout",
  "featured-mosaic-content": "OiXoYq_featured-mosaic-content",
  "featured-mosaic-content--dark-text": "OiXoYq_featured-mosaic-content--dark-text",
  "featured-mosaic-content--light-text": "OiXoYq_featured-mosaic-content--light-text",
  "featured-mosaic-content__description": "OiXoYq_featured-mosaic-content__description",
  "featured-mosaic-content__description__text": "OiXoYq_featured-mosaic-content__description__text",
  "featured-mosaic-content__pill": "OiXoYq_featured-mosaic-content__pill",
  "featured-mosaic-content__pill--blue": "OiXoYq_featured-mosaic-content__pill--blue",
  "featured-mosaic-content__pill--green": "OiXoYq_featured-mosaic-content__pill--green",
  "featured-mosaic-content__pill--purple": "OiXoYq_featured-mosaic-content__pill--purple",
  "featured-mosaic-content__pill--red": "OiXoYq_featured-mosaic-content__pill--red",
  "featured-mosaic-content__pill--yellow": "OiXoYq_featured-mosaic-content__pill--yellow",
  "featured-mosaic-content__title": "OiXoYq_featured-mosaic-content__title",
  "featured-mosaic-item": "OiXoYq_featured-mosaic-item",
  "featured-mosaic-secondary-items": "OiXoYq_featured-mosaic-secondary-items",
  "featured-mosaic-slideshow": "OiXoYq_featured-mosaic-slideshow",
  "featured-mosaic-slideshow-inner": "OiXoYq_featured-mosaic-slideshow-inner",
  "mosaic-slideshow-indicator": "OiXoYq_mosaic-slideshow-indicator",
  "mosaic-slideshow-indicator__dot": "OiXoYq_mosaic-slideshow-indicator__dot",
});
